var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.0914 11.4542L37.9477 7.94037C39.7502 6.8588 40.6516 6.31803 41.3932 6.38717C42.0398 6.44744 42.6298 6.78146 43.0141 7.30494C43.455 7.90528 43.455 8.95635 43.455 11.0585V20.9408C43.455 23.0428 43.455 24.094 43.0141 24.6944C42.6298 25.2178 42.0398 25.5519 41.3932 25.6121C40.6516 25.6812 39.7502 25.1406 37.9477 24.059L32.0914 20.5451M9.81863 29.636H24.8186C27.3643 29.636 28.6373 29.636 29.6095 29.1406C30.4648 28.7049 31.1602 28.0094 31.5959 27.1542C32.0914 26.1819 32.0914 24.909 32.0914 22.3633V9.63601C32.0914 7.09033 32.0914 5.81746 31.5959 4.84514C31.1602 3.98985 30.4648 3.29449 29.6095 2.85871C28.6373 2.36328 27.3643 2.36328 24.8186 2.36328H9.81863C7.27294 2.36328 6.00008 2.36328 5.02776 2.85871C4.17247 3.29449 3.4771 3.98985 3.04133 4.84514C2.5459 5.81746 2.5459 7.0903 2.5459 9.63601V22.3633C2.5459 24.909 2.5459 26.1819 3.04133 27.1542C3.4771 28.0094 4.17247 28.7049 5.02776 29.1406C6.00008 29.636 7.27292 29.636 9.81863 29.636Z",
    stroke: "#00C853",
    strokeWidth: 4.54545,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPost);
export default __webpack_public_path__ + "static/media/videoPost.1548f7c76a0006b02b724da39093f1a6.svg";
export { ForwardRef as ReactComponent };